import parsePlayerOptions from "utils/parsePlayerOptions";
import { useMemo } from "react";

// TODO: Use ReactRouter for this instead of `window.location.search`
export function usePlayerOptions() {
  const search = window.location.search;

  return useMemo(
    () =>
      parsePlayerOptions(
        {},
        {
          windowLocationSearch: search,
          offline: window.offline,
        },
      ),
    [search],
  );
}
